import React, { useEffect, useState } from "react";
import AdminDashboard from "../AdminDashboard/AdminDashboard";
import {
  userListPdf,
  userListExcel,
  getSubCategoriesDropdown,
  oldApplicationsListPdf,
  oldApplicationsListExcel,
} from "../../../services/api/admin";
import { HomeIcon } from "../../../components/Application/ApplicationIcon";
import ReactPaginate from "react-paginate";
import NotFoundTable from "../../../components/notFound/NotFoundTable";
import { printData } from "../../../Utils/common";
import { useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { EyeIcon } from "../AdminIcon";
import { Message } from "../../../components/message";
import { CgFileDocument } from "react-icons/cg";
import { PdfBaseUrl } from "../../../Utils/Utils";
import { Spinner } from "react-bootstrap";
import { getOldApplicationListData } from "../../../services/api/admin";
import TotalRecords from "../../../components/notFound/TotalRecords";
import Select from "react-select";
import { stateDistrict } from "../../../services/api/auth";

const OldApplications = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const [applicationList, setApplicationList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0); // Total number of pages
  const [orderBy, setOrderBy] = useState("asc");
  const [deleteData, setDeleteData] = useState();
  const [apiMessage, setApiMessage] = useState({ type: "", message: "" });
  const [tableDataLoaded, setTableDataLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState();
  const [sortBy, setSortBy] = useState("district");
  const [searchData, setSearchData] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [pdfDownLoading, setPdfDownLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [searchSubCategory, setSearchSubCategory] = useState();
  const [districtList, setDistrictList] = useState([]);
  const [searchDistrict, setSearchDistrict] = useState();

  useEffect(() => {
    applicationDataList("district", "1", "asc", "", "", "");
    getSubCategoryList();
    loadDistricts();
  }, []);

  const resetFilter = () => {
    setSearchSubCategory("");
    applicationDataList(sortBy, 1, orderBy, searchData, "", "");
  };

  const loadDistricts = async () => {
      try {
        const response = await stateDistrict();
        const data = response.data.data.map((district) => ({
          label: district.name_en,
          value: district.id,
        }));
        setDistrictList(data);
      } catch (error) {
        setApiMessage({ type: "error", message: error?.message });
      }
    };

  const getSubCategoryList = async () => {
      try {
        const subCategoryList = await getSubCategoriesDropdown();
        const data = subCategoryList?.data?.map((item) => ({
          value: item?.id,
          label: item?.category_name,
        }));
        setSubCategoryList(data);
      } catch (err) {
        setApiMessage({ type: "error", message: err?.message });
      }
    };

  const applicationDataList = async (sortBy, pageNo, orderBy, searchBy, searchedSubCategory, searchedDistrict) => {
    try {
      setSearchData(searchBy);
      setOrderBy(orderBy);
      setSortBy(sortBy);
      const applicationListData = await getOldApplicationListData(
        sortBy,
        orderBy,
        searchBy,
        pageNo,
        searchedSubCategory?.value ? searchedSubCategory?.value : "",
        searchedDistrict?.value ? searchedDistrict?.value : ""
      );
      if (applicationListData.status == 200) {
        const data = applicationListData?.data?.data;
        setTotalPages(
          Math.ceil(applicationListData?.data?.total / applicationListData?.data?.per_page)
        );
        setCurrentPage(pageNo > 0 ? pageNo - 1 : pageNo);
        setApplicationList(data);
        setTotalRecords(applicationListData?.data?.total ? applicationListData?.data?.total : 0);
      } else {
        setApplicationList([]);
        setTotalRecords(0);
        setApiMessage({ type: "error", message: applicationListData?.message });
      }
      setTableDataLoaded(true);
    } catch (err) { 
      setTotalRecords(0);
      setApiMessage({ type: "error", message: err?.message });
      setTableDataLoaded(true);
    }
  };

  const handlePageChange = (selectedPage) => {
    applicationDataList(sortBy, selectedPage.selected + 1, orderBy, searchData, searchSubCategory, searchDistrict); // Increment by 1 if the API starts page numbers from 1
  };

  const pdfDownload = async () => {
    try {
      setPdfDownLoading(true);
      const response = await oldApplicationsListPdf(searchSubCategory?.value ? searchSubCategory?.value : "");
      setPdfDownLoading(false);
      window.open(
        `${PdfBaseUrl()}/${response.folder_path}/${response.file_name}`
      );
    } catch (err) {
      setPdfDownLoading(false);
      setApiMessage({ type: "error", message: err?.message });
    }
  };

  const excelDownload = async () => {
    try {
      const response = await oldApplicationsListExcel(searchSubCategory?.value ? searchSubCategory?.value : "");
      window.open(response?.file_path);
    } catch (err) {
      setApiMessage({ type: "error", message: err?.message });
    }
  };

  const exportPrint = async () => {
    try {
      const response = await oldApplicationsListPdf(searchSubCategory?.value ? searchSubCategory?.value : "");
      if (response) {
        printData(response);
      }
    } catch (err) {
      setApiMessage({ type: "error", message: err?.message });
    }
  };

  return (
    <AdminDashboard>
      <div className="aod-outer">
        {apiMessage && (
          <Message
            apiMessage={apiMessage}
            setApiMessage={setApiMessage}
          ></Message>
        )}
        <div className="ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb">
          <div>
            <HomeIcon />
            <b onClick={() => navigate("/admin/")}>Home /</b> <span>Old Applications</span>
          </div>
          <div className="dropdown download_file_dropdown ms-auto d-flex gap-2 mb-3 flex-wrap align-items-center">
            {pdfDownLoading ? (
              <a className=" px-2 btn btn-danger btn-sm d-none">
                {" "}
                <i className="fa fa-file-pdf me-1"></i>
                <span>PDF</span>
                <Spinner
                  animation="border"
                  className="pdf-spinner"
                  role="status"
                  style={{ marginLeft: "5px" }}
                >
                  <span className="visually-hidden"></span>
                </Spinner>
              </a>
            ) : (
              <a
                className=" px-2 btn btn-danger btn-sm d-none"
                onClick={() => pdfDownload()}
              >
                {" "}
                <i className="fa fa-file-pdf me-1"></i> PDF
              </a>
            )}
            <a
              className=" px-2 btn btn-success btn-sm"
              onClick={() => excelDownload()}
            >
              <i className="fa fa-file-excel  me-1"></i>
              Excel{" "}
            </a>
            <a
              className=" px-2 btn btn-info  btn-sm d-none"
              onClick={() => exportPrint()}
            >
              <i className="fa fa-print me-1"></i>
              Print
            </a>
          </div>
        </div>
        <div className="aod-inner pt-0">
          <div className="aod-inner pt-0">
            <div className="aod-bottom">
              <div className="adm-tabs-outer d-flex justify-content-between">
                <h4 className="mb-0">Old Applications </h4>
                <div className="position-relative w-25">
                  <input
                    className="px-2 form-control"
                    placeholder="Search"
                    type="text"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      applicationDataList(sortBy, 1, orderBy, e.target.value, searchSubCategory, searchDistrict);
                    }}
                  />
                  {searchTerm && (
                    <button
                      className="btn btn-clear position-absolute"
                      onClick={(e) => {
                        setSearchTerm("");
                        applicationDataList(sortBy, 1, orderBy, e.target.value);
                      }}
                      style={{
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        border: "none",
                        background: "transparent",
                        fontSize: "1rem",
                        cursor: "pointer",
                      }}
                    >
                      &times;
                    </button>
                  )}
                </div>
              </div>
              <div className="aod-head"></div>
              <div className="row py-4">
                <div className="col-md-4 aod-resp-tab">
                    <div className="suf-input-box aod-form-input mb-2">
                      <Select
                        className="menu_open_select w-100"
                        classNamePrefix="ad-menu_open_select_class"
                        aria-label="Default select example"
                        value={searchSubCategory}
                        options={subCategoryList}
                        onChange={(e) => {
                          setSearchSubCategory(e);
                          applicationDataList(
                            sortBy, 1, orderBy, searchData, e, searchDistrict
                          )
                        }}
                        placeholder="Select Sub Category"
                      />
                    </div>
                  </div>
                  <div className="col-md-4 aod-resp-tab d-none">
                    <div className="suf-input-box aod-form-input mb-2">
                      <Select
                        className="menu_open_select w-100"
                        classNamePrefix="ad-menu_open_select_class"
                        aria-label="Default select example"
                        value={searchDistrict}
                        options={districtList}
                        onChange={(e) => {
                          setSearchDistrict(e);
                          applicationDataList(
                            sortBy, 1, orderBy, searchData, searchSubCategory, e
                          )
                        }}
                        placeholder="Select District"
                      />
                    </div> 
                  </div>
                  <div className="col-md-6">
                    <button
                      onClick={resetFilter}
                      className="ad-reset-btn w-auto px-4"
                    >
                      Reset
                    </button>
                  </div>
                <TotalRecords totalRecords={totalRecords}></TotalRecords>
              </div>
              <div className="ad-reg-table">
                <Table size="sm" className="ad-cat-table">
                  <thead>
                    <tr>
                      <th className="ad-sno">S. No</th>
                      <th className="ad-long cursor-pointer"
                        onClick={(e) =>
                          applicationDataList(
                            "unique_id",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            searchSubCategory,
                            searchDistrict
                          )
                        }>Customer Id
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>{" "}
                      </th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          applicationDataList(
                            "category_name",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            searchSubCategory,
                            searchDistrict
                          )
                        }
                      >
                        Sub Category
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>{" "}
                      </th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          applicationDataList(
                            "district",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            searchSubCategory,
                            searchDistrict
                          )
                        }
                      >
                        District
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>{" "}
                      </th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          applicationDataList(
                            "application_no",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            searchSubCategory,
                            searchDistrict
                          )
                        }
                      >
                        Application No
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>{" "}
                      </th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          applicationDataList(
                            "accomodation_name",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            searchSubCategory,
                            searchDistrict
                          )
                        }
                      >
                        Unit Name
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>{" "}
                      </th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          applicationDataList(
                            "mobile",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            searchSubCategory,
                            searchDistrict
                          )
                        }
                      >
                        Mobile Number
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>{" "}
                      </th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          applicationDataList(
                            "payment_reference_id",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            searchSubCategory,
                            searchDistrict
                          )
                        }
                      >
                        Payment Id
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>{" "}
                      </th>
                      <th
                        className="ad-long cursor-pointer"
                        onClick={(e) =>
                          applicationDataList(
                            "status",
                            currentPage + 1,
                            orderBy === "asc" ? "desc" : "asc",
                            searchData,
                            searchSubCategory,
                            searchDistrict
                          )
                        }
                      >
                        Status
                        <span>
                          <i className="fa-solid fa-sort"></i>
                        </span>{" "}
                      </th>
                      <th className="ad-long">Remarks</th>
                      <th className="ad-long">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {applicationList?.length > 0 ? (
                      applicationList?.map((item, index) => (
                        <tr key={index}>
                          <td>{currentPage * 10 + (index + 1)}</td>
                          <td>{item?.unique_id ? item?.unique_id : "--"}</td>
                          <td>{item?.category_name ? item?.category_name : "--"}</td>
                          <td>{item?.district ? item?.district : "--"}</td>
                          <td>{item?.application_no ? item?.application_no : "--"}</td>
                          <td>{item?.accomodation_name ? item?.accomodation_name : "--"}</td>
                          <td>{item?.mobile ? item?.mobile : "--"}</td>
                          <td>{item?.payment_reference_id ? item?.payment_reference_id : "--"}</td>
                          <td>{item?.status ? item?.status : "--"}</td>
                          <td dangerouslySetInnerHTML={{ __html: item?.remarks || '--' }} />
                          <td className="icon-col">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`edit-tooltip-${item.id}`}>
                                  View Application Data
                                </Tooltip>
                              }
                            >
                              <span
                                className="ad-cat-edit"
                                onClick={() => {
                                  navigate("/admin/old-application-view", {
                                    state: {
                                      data: item,
                                    },
                                  });
                                }}
                              >
                                <EyeIcon />
                              </span>
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`edit-tooltip-${item.id}`}>
                                  View Documents
                                </Tooltip>
                              }
                            >
                              <span
                                className="ad-cat-edit"
                                onClick={() => {
                                  navigate("/admin/old-document", {
                                    state: {
                                      data: item,
                                    },
                                  });
                                }}
                              >
                                <CgFileDocument />
                              </span>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      ))
                    ) : tableDataLoaded ? (
                      <NotFoundTable colSpan="8"></NotFoundTable>
                    ) : (
                      <></>
                    )}
                  </tbody>
                </Table>
                {totalPages > 1 && applicationList?.length > 0 && (
                  <div className="d-flex w-100 justify-content-end">
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={totalPages} // Total number of pages from API
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={1}
                      onPageChange={handlePageChange} // Method to handle page click
                      forcePage={currentPage}
                      containerClassName={"pagination justify-content-center"} // Custom CSS classes
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={`page-item${
                        !applicationList?.length > 0 ? " disabled" : ""
                      }`}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminDashboard>
  );
};

export default OldApplications;
